import { API_BASE_URL } from "@/consts";
import axios from "axios";
import { snippetApiToken } from "@/composables/useSnippetApiToken";

const BASE = `${API_BASE_URL}/snippet-analytics`;

const authHeaders = () => ({
  Authorization: `Bearer ${snippetApiToken()}`,
});

const get = async (path, params) => {
  try {
    const { data } = await axios.get(`${BASE}${path}`, {
      params,
      headers: authHeaders(),
    });
    return data.success ? data.data : null;
  } catch (error) {
    console.error(`Snippet analytics request failed: ${path}`, error);
    return null;
  }
};

export const fetchPlacements = (params) => get("/placements", params);
export const fetchPace = (params) => get("/revenue/pace", params);
export const fetchRunRate = (params) => get("/revenue/run-rate", params);
export const fetchHourly = (params) => get("/revenue/hourly", params);
export const fetchBreakdown = (params) => get("/revenue/breakdown", params);
export const fetchDaily = (params) => get("/revenue/daily", params);
